import {getJSON, postJSON, getJSONP} from './myaxios';
import process_award from '../components/ConfigUI/Lottery/process_award';

export function getAward(sub_act_id) {
  getJSON('//vipact3.api.mgtv.com/api/v1/act/lot/sublot', {
    ticket: window.$bus.user.ticket,
    act_name: window.rootdata.act_name,
    sub_act_id
  }).then(res => {
    if (!res) {
      return;
    }
    if (res.ret === 0) {
      process_award(res.data);
    } else {
      window.$toast(res.msg);
    }

  })

}



// WEBPACK FOOTER //
// ./src/api/getAward.js